import saveFile from 'save-as-file';

const __CLIENT_ROUTES = {
  LIST: "/client/list",
  DETAIL: "/client/detail",
  CREATE: "/client/add",
  UPDATE: "/client/update",
  DELETE: "/client/delete",
  GET_TEXTS: "/client/texts/get",
  SET_TEXTS: "/client/texts/set"
};
const __INSTITUTION_ROUTES = {
  LIST: "/institution/list",
  DETAIL: "/institution/detail",
  CREATE: "/institution/add",
  UPDATE: "/institution/update",
  DELETE: "/institution/delete",
}
const __USER_ROUTES = {
  LIST: "/user/list",
  DETAIL: "/user/detail",
  CREATE: "/user/add",
  UPDATE: "/user/update",
  DELETE: "/user/delete",
  VERIFY: "/user/verify-by-token"
}

class DataFetcher {
  constructor() {
    this.bridgeUrl = `${process.env.REACT_APP_BRIDGE_URL}/`;
    this._quiet = false;
    this._log(`online -> ${this.bridgeUrl}`);
  }

  get CLIENT() {
    return __CLIENT_ROUTES
  }
  get INSTITUTION() {
    return __INSTITUTION_ROUTES
  }
  get USER() {
    return __USER_ROUTES
  }

  _log(msg) {
    !this._quiet && console.log("DataFetcher", msg, Date.now());
  }

  fetch(endpoint, body, area = 'admin') {
    let blobData = null;
    this._log(`fetch -> ${endpoint} with ${JSON.stringify(body)}`);
    return fetch(`${this.bridgeUrl}${area}${endpoint}`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(r => {
        if(r.headers.get('content-disposition') && r.headers.get('content-disposition').indexOf('attachment;') === 0){
          blobData = {fn: r.headers.get('content-disposition').split('attachment;')[1].split("filename=")[1].trim()};
          return r.blob();
        }
        return r.json()
      })
      .then(r => {
        if(r instanceof Blob){
          const file = new File([r], {type: 'octet/stream'});
          saveFile(file, blobData.fn);//, 1000*60*10);
          return {success: true, msg: "FILE_DOWNLOADED_SUCCESSFULLY"};
        }
        return r;
      })
      .catch(e => console.error(e));
  }
}

export default new DataFetcher();
